export default __webpack_public_path__ + "static/media/hand-pdf.5d20dd3c.svg";